import React from "react";
import Button, { ButtonType } from "../Assets/Button";
import { IUser } from "../../models/userData.model";
import { ILeadUser } from "../../models/LeadData.model";

interface BulkAssigneeProps {
  selectedCount: number;
  assigneeList: (IUser | ILeadUser)[];
  selectedAssignee: string;
  setSelectedAssignee: (value: string) => void;
  onUpdate: () => void;
  onCancel: () => void;
}

const BulkAssignee: React.FC<BulkAssigneeProps> = ({
  selectedCount,
  assigneeList,
  selectedAssignee,
  setSelectedAssignee,
  onUpdate,
  onCancel,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center gap-4 mb-4 p-3 bg-blue-50 rounded-lg shadow">
      <div className="text-sm font-medium text-blue-700">
        {selectedCount} User(s) selected
      </div>

      <select
        value={selectedAssignee}
        onChange={(e) => setSelectedAssignee(e.target.value)}
        className="p-2 text-xs rounded-md border border-gray-300 bg-white"
      >
        <option value="">Select Assignee</option>
        {assigneeList.map((user) => (
          <option key={user._id} value={user._id}>
            {user.username}
          </option>
        ))}
      </select>

      <Button type={ButtonType.Extra} onClick={onUpdate} className="text-xs">
        Update Assignee
      </Button>

      <Button type={ButtonType.Cancel} onClick={onCancel} className="text-xs">
        Cancel
      </Button>
    </div>
  );
};

export default BulkAssignee;
